import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=a60dc02e&scoped=true&"
import script from "./Primary.vue?vue&type=script&lang=js&"
export * from "./Primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60dc02e",
  null
  
)

component.options.__file = "Primary.vue"
export default component.exports